import { AxiosResponse } from 'axios';
import { RoleListResponse, RoleModel } from 'types/entity';
import { http } from './settings';

export const fetchUnusedRoles = (projectId: string): Promise<RoleModel[]> => http.get(`/projects/${projectId}/roles/unused`)
  .then((value: AxiosResponse<RoleListResponse>) => value.data.roles || []);
